import LinkToDocusaurus from '../LinkToDocusaurus'
import { Paragraph } from '@eggplant/pattern-library'
import { sutConnections } from '../../docs-routes'

interface Props {
  isSingleSystem?: boolean
}

const defaultContent =
  <Paragraph>
    If your SUT is only accessible from specific Execution Environments (e.g. if your SUT
    is connected to a particular Execution Environment via USB, or accessible only from certain
    network segments, etc), you can specify them here. Leave this field empty if your SUT can be reached
    from all Execution Environments.
  </Paragraph>

const singleSystemContent =
  <Paragraph>
    A Single System connection allows you to control the same Windows machine where the Execution
    Environment is running. Please choose the Execution Environment that you would like to control.
  </Paragraph>

const ExecutionEnvironmentInfo = ({
  isSingleSystem = false
}: Props) =>
  <>
    {
      isSingleSystem
        ? singleSystemContent
        : defaultContent
    }
    <br />
    <Paragraph>
      <LinkToDocusaurus path={sutConnections}>Learn more in the DAI documentation</LinkToDocusaurus>
    </Paragraph>
  </>

export default ExecutionEnvironmentInfo
